import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "@/components/site/Reveal";
import { PROCESS } from "@/data/content";

export default function Process() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start center", "end center"],
  });
  const scaleY = useTransform(scrollYProgress, [0, 1], [0, 1]);

  return (
    <section
      className="relative border-t border-white/10 bg-[#050505] py-24 md:py-40"
      data-testid="process-section"
    >
      <div className="mx-auto max-w-[1600px] px-5 md:px-10">
        <Reveal>
          <span className="font-mono text-xs uppercase tracking-[0.3em] text-[#0033ff]">
            05 — Method
          </span>
          <h2 className="mt-6 max-w-3xl font-display text-4xl font-extrabold uppercase leading-[0.95] tracking-tighter text-[#f4f4f5] md:text-6xl lg:text-7xl">
            A disciplined path to production.
          </h2>
        </Reveal>

        <div ref={ref} className="relative mt-20 pl-8 md:pl-16">
          {/* track */}
          <div className="absolute left-0 top-0 h-full w-px bg-white/10 md:left-4" />
          <motion.div
            style={{ scaleY, transformOrigin: "top" }}
            className="absolute left-0 top-0 h-full w-px bg-[#0033ff] md:left-4"
          />

          {PROCESS.map((p, i) => (
            <motion.div
              key={p.no}
              initial={{ opacity: 0, x: 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: i * 0.06 }}
              className="relative grid grid-cols-1 gap-4 border-b border-white/10 py-10 last:border-b-0 md:grid-cols-12 md:py-14"
              data-testid={`process-${p.no}`}
            >
              <span className="absolute -left-8 top-11 h-2 w-2 rounded-full bg-[#0033ff] md:-left-[3.15rem]" />
              <div className="md:col-span-2">
                <span className="font-mono text-xs text-[#52525b]">{p.no}</span>
              </div>
              <div className="md:col-span-4">
                <h3 className="font-display text-2xl font-extrabold uppercase tracking-tight text-[#f4f4f5] md:text-4xl">
                  {p.title}
                </h3>
              </div>
              <div className="md:col-span-6">
                <p className="max-w-lg font-mono text-sm leading-relaxed text-[#a1a1aa]">
                  {p.body}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
